import React, { useMemo } from "react";
import "./ArticleBox.scss";
import { Link, useNavigate } from "react-router-dom";
import PostImage from "../../containers/SinglePost/img/PostImage.js";
import { getPreUrlTitle } from "../../shared/utillity.js";
import Buttons from "../../UI/Button/Buttons.js";
import { useIdContext } from "../../shared/IdProvider.js";

export default function ArticleBox(props) {
  const articleData = props.n;
  const { allCategories } = useIdContext();
  const navigate = useNavigate();
  const preUrlTitle = useMemo(() => getPreUrlTitle(articleData, allCategories, false), [articleData, allCategories]);
  const categoryLink = getPreUrlTitle(articleData, allCategories, true);
  const displayTitle = articleData.title_2 || articleData.title;

  return (
    <div className={props.classes}>
      <div className="artBox-wrapper">
        <Link to={preUrlTitle} className="artBox-img">
          <PostImage src={articleData.pics} alt={displayTitle} />
        </Link>
        <div className="artBox-desc">
          <Link to={preUrlTitle}>
            <h3>{displayTitle}</h3>
          </Link>
          <div className="artBox-desc-other">
            <Link to={categoryLink}>{articleData.category}</Link>
          </div>
          <span className="artBox-lead">{articleData.lead}...</span>
          <Buttons
            classes="artBox-btn"
            clicked={() => {
              navigate(preUrlTitle);
            }}
          >
            Nastavi čitanje
          </Buttons>
        </div>
      </div>
    </div>
  );
}
